<template>
  <el-main class="materialwrap">
    <div class="mybread">
      <p><i class="el-icon-location"></i>当前位置：</p>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>个人事务管理</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: `/expense` }">报销管理</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: `/expense/person?id=${userArr.id}` }">报销申请</el-breadcrumb-item>
        <el-breadcrumb-item>报销详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="header">
      <div class="header-info">
        <h1>{{ form.description }}</h1>
        <p style="font-size: 20px; font-weight: 550;">{{ userArr.realname }} {{ userArr.en_name }} </p>
        <p>{{ userArr.department?.en_name }} - {{ userArr.role?.role_name }}</p>
        <p>直属领导：{{ userArr.leader_name }} {{ userArr.leader_en_name }} </p>
        <p>报销月份：{{ form.expense_date_month }}月</p>
      </div>
      <div class="header-status">
        <div>
          <div class="button" :style="{ 'backgroundColor': dd.expense_status_c[form.status]?.color }">
            {{ dd.expense_status_c[form.status]?.word }}
          </div>
        </div>
      </div>
    </div>
    <!-- 报销明细 -->
    <div class="table">
      <h3 class="ntitle">报销明细</h3>
      <div class="operater">
        <div class="linkline" @click="editExpense" style="margin-right: 5px;" v-if="NodeInclude('185') && (form.staff[0].id == userId || level == '1')">{{ form.leader_check_status != '1' || level == '1' ? '编辑' : '主管审核中...' }}</div>
        <div class="linkbox" @click="showLeaderCheck" style="margin-right: 15px;"
          v-if="((form.leader_check == '1' && (NodeInclude('189') || NodeInclude('342'))) || level == '1') && form.leader_check_status != '2'">主管审核</div>
        <div class="button" :style="{ 'backgroundColor': dd.leader_check_status_c[form.leader_check_status]?.color }">
          {{ dd.leader_check_status_c[form.leader_check_status]?.word }}
        </div>
      </div>
      <div class="download">
        <el-button @click="exportExpenseAttachmentToExcel('')" :disabled="!fileNum" v-if="NodeInclude('191')"><i class="el-icon-download"></i>下载附件</el-button>
        <el-button @click="exportExpenseStaffToExcel" v-if="NodeInclude('190')"><i class="el-icon-download"></i>下载表单</el-button>
      </div>
      <div>
        <el-table :data="itemList" stripe border scroll highlight-current-row>
          <el-table-column type="index" label="序号" header-align="center" align="center" min-width="80" />
          <el-table-column prop="service_type_name" label="服务类目" header-align="center" align="center" min-width="120" />
          <el-table-column prop="expense_amount" label="金额（元）" header-align="center" align="right" min-width="120" />
          <el-table-column prop="description" label="备注" header-align="center" align="left" min-width="200" />
          <el-table-column prop="brand" label="关联品牌" header-align="center" align="center" min-width="200">
            <template slot-scope="scope">
              {{ scope.row.brand ? scope.row.brand : '/' }}
            </template>
          </el-table-column>
          <el-table-column prop="contract_no_name" label="关联项目" header-align="center" align="center" min-width="200">
            <template slot-scope="scope">
              {{ scope.row.project_id != '0' ? `${scope.row.project?.contract_no}-${scope.row.project?.contract_name}` :
                '/' }}
            </template>
          </el-table-column>
          <el-table-column prop="file" label="附件" header-align="center" align="center" min-width="200">
            <template slot-scope="scope">
              <div class="inner">
                <span>{{ scope.row.atta_str[0]?.origin_name }}</span>
                <span @click="exportExpenseAttachmentToExcel(scope.row.atta_str[0]?.id)" v-if="scope.row.atta_str[0]?.origin_name && NodeInclude('191')" target="_blank"><i class="el-icon-download"></i></span>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="expense">
        <div>当前填报总金额：{{ form.total_expense_amount }}</div>
        <div>业务金额：{{ form.total_business_amount }}</div>
        <div>日常金额：{{ form.total_daily_amount }}</div>
      </div>
    </div>
    <!-- 支付状态 -->
    <div class="base1">
      <h3 class="ntitle">支付状态</h3>
      <div class="operater">
        <div class="linkbox" @click="showFinanceCheck" style="margin-right: 15px;" v-if="(NodeInclude('192') && form.finance_check_status != '2') || level == '1'">财务审核</div>
        <div class="linkbox" @click="updatePayClick" v-if="NodeInclude('193')">更新支付状态</div>
      </div>
      <ul>
        <li>
          <p>
            <label>报销说明：</label><a>{{ form.description }}</a>
          </p>
          <p>
            <label>报销月份：</label><a>{{ form.expense_date_month }}月</a>
          </p>
          <p>
            <label>支付时间：</label><a>{{ form.pay_time != '0000-00-00 00:00:00' ? form.pay_time : '暂无' }}</a>
          </p>
          <p>
            <label>支付凭证附件：</label>
            <template>
              <ul class="bbox">
                <li v-for="(_it, _id) in form.pay_str" :key="_id">
                  <template v-if="_it.origin_name">
                    <div class="origin_name" style="width: 600px;">
                      <a style="max-width: 550px;">
                        <div class="origin-name">{{ _it.origin_name }}</div>
                      </a>
                      <a style="width: 50px;">
                        <el-link type="primary" style="margin-right:5px" :href="_it.httpImg" target="_blank">查看</el-link>
                      </a>
                    </div>
                  </template>
                  <el-col v-else>暂无附件</el-col>
                </li>
              </ul>
            </template>
          </p>
        </li>
        <li>
          <p>
            <label>报销金额：</label><a>{{ form.expense_amount }}</a>
          </p>
          <p>
            <label>财务审核状态：</label>
            <a>
              <div class="circle-tag"
                :style="{ 'background': dd.finance_check_status_c[form.finance_check_status]?.color }">
                <div class="word">{{ dd.finance_check_status_c[form.finance_check_status]?.word }}</div>
              </div>
            </a>
          </p>
          <p>
            <label>支付状态：</label>
            <a>
              <div class="circle-tag" :style="{ 'background': dd.pay_status_c[form.pay_status]?.color }">
                <div class="word">{{ dd.pay_status_c[form.pay_status]?.word }}</div>
              </div>
            </a>
          </p>
        </li>
      </ul>
    </div>
    <!-- 项目动态 -->
    <div class="history">
      <h3 class="ntitle">项目动态</h3>
      <el-form ref="trackForm" :model="trackForm" style="float:right;">
        <el-form-item label="" prop="track_event">
          <el-col :span="20">
            <el-select v-model="trackForm.event_id" placeholder="请选择流程" style="margin-right: 0; width: 100%;"
              @change="trackChange">
              <el-option label="全部流程" value="0"></el-option>
              <el-option label="支付管理" value="4"></el-option>
              <el-option label="报销管理" value="12"></el-option>
            </el-select>
          </el-col>
        </el-form-item>
      </el-form>
      <ul class="linehead">
        <li>时间</li>
        <li>操作人</li>
        <li>流程</li>
        <li>详情</li>
      </ul>
      <div class="timeline">
        <el-timeline>
          <el-timeline-item :timestamp="compDate(item)" placement="top" v-for="(item, index) in myTrackList" :key="index"
            :class="{ child: !item.parent }" :icon="item.icon" :color="item.color">
            <div class="ico-edit">
              <el-dropdown trigger="click" placement="bottom-start" @command="handleCommand">
                <i class="el-icon-edit" @click="setTimeForm(item)"></i>
                <template #dropdown>
                  <el-dropdown-menu>
                    <el-dropdown-item command="a" v-if="NodeInclude('194')">新增</el-dropdown-item>
                    <el-dropdown-item command="b" v-if="NodeInclude('194')">编辑</el-dropdown-item>
                    <el-dropdown-item command="c" v-if="NodeInclude('322')">删除</el-dropdown-item>
                  </el-dropdown-menu>
                </template>
              </el-dropdown>
            </div>
            <div class="mycard" :class="{ active: parentActive(item), parent: item.parent }" @click="trigger(item)">
              <!-- {{item}} -->
              <i class="point" v-if="item.point">+{{ item.point }}</i>
              <div v-if="!item.parent">
                <ul class="ul">
                  <li>
                    <span>{{ item.bkUserArr ? item.bkUserArr.realname : '暂无' }}</span>
                  </li>
                  <li>
                    <span>{{ item.eventName }}</span>
                  </li>
                  <li v-html="item.info"></li>
                </ul>
              </div>
            </div>
          </el-timeline-item>
        </el-timeline>
      </div>
    </div>

    <el-dialog title="报销主管审核" :visible.sync="leaderCheckShow" width="600px">
      <ul class="aul ulist" style="padding:0">
        <li>
          <span>报销说明：</span>
          <span>{{ form.description }}</span>
        </li>
        <li>
          <span>报销金额：</span>
          <span>{{ form.expense_amount }}</span>
        </li>
        <li>
          <span>申请人：</span>
          <span>{{ userArr.realname }} {{ userArr.en_name }}</span>
        </li>
        <el-form ref="leaderCheckForm" :model="leaderCheckForm" label-width="140px" label-position="left" class="ulform">
          <el-form-item label="审核：" prop="leader_check_status">
            <el-col :span="24">
              <el-radio-group v-model="leaderCheckForm.leader_check_status">
                <el-radio label="2">通过</el-radio>
                <el-radio label="3">不通过</el-radio>
              </el-radio-group>
            </el-col>
          </el-form-item>
          <template v-if="leaderCheckForm.leader_check_status == '2'">
            <el-form-item label="" prop="leader_check_info">
              <el-col :span="24">
                <el-input type="textarea" spellcheck="false" :autosize="{ minRows: 4 }" placeholder="请输入内容"
                  v-model="leaderCheckForm.leader_check_info">
                </el-input>
              </el-col>
            </el-form-item>
          </template>
          <template v-if="leaderCheckForm.leader_check_status == '3'">
            <el-form-item label="" prop="leader_no_check_info">
              <el-col :span="24">
                <el-input type="textarea" spellcheck="false" :autosize="{ minRows: 4 }" placeholder="请输入内容"
                  v-model="leaderCheckForm.leader_no_check_info">
                </el-input>
              </el-col>
            </el-form-item>
          </template>
        </el-form>
      </ul>
      <span slot="footer" class="dialog-footer">
        <el-button @click="leaderCheckShow = false">取 消</el-button>
        <el-button type="primary" @click="handleLeaderCheck">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="报销财务审核" :visible.sync="financeCheckShow" width="600px">
      <ul class="aul ulist" style="padding:0">
        <li>
          <span>报销说明：</span>
          <span>{{ form.description }}</span>
        </li>
        <li>
          <span>报销金额：</span>
          <span>{{ form.expense_amount }}</span>
        </li>
        <li>
          <span>申请人：</span>
          <span>{{ userArr.realname }} {{ userArr.en_name }} </span>
        </li>
        <el-form ref="financeCheckForm" :model="financeCheckForm" label-width="140px" label-position="left"
          class="ulform">
          <el-form-item label="审核：" prop="finance_check_status">
            <el-col :span="24">
              <el-radio-group v-model="financeCheckForm.finance_check_status">
                <el-radio label="2">通过</el-radio>
                <el-radio label="3">不通过</el-radio>
              </el-radio-group>
            </el-col>
          </el-form-item>
          <template v-if="financeCheckForm.finance_check_status == '2'">
            <el-form-item label="" prop="finance_check_info">
              <el-col :span="24">
                <el-input type="textarea" spellcheck="false" :autosize="{ minRows: 4 }" placeholder="请输入内容"
                  v-model="financeCheckForm.finance_check_info">
                </el-input>
              </el-col>
            </el-form-item>
          </template>
          <template v-if="financeCheckForm.finance_check_status == '3'">
            <el-form-item label="" prop="finance_no_check_info">
              <el-col :span="24">
                <el-input type="textarea" spellcheck="false" :autosize="{ minRows: 4 }" placeholder="请输入内容"
                  v-model="financeCheckForm.finance_no_check_info">
                </el-input>
              </el-col>
            </el-form-item>
          </template>
        </el-form>
      </ul>
      <span slot="footer" class="dialog-footer">
        <el-button @click="financeCheckShow = false">取 消</el-button>
        <el-button type="primary" @click="handlefinanceCheck">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog :title="timeForm.option == 1 ? '新增报销动态' : '编辑报销动态'" :visible.sync="trackShow" width="600px">
      <el-form ref="timeForm" :model="timeForm" label-width="140px" label-position="left" class="ulform">
        <el-form-item label="选择时间：" prop="create_time">
          <el-col :span="24">
            <el-date-picker v-model="timeForm.create_time" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="选择时间" style="width:100%;">
            </el-date-picker>
          </el-col>
        </el-form-item>
        <el-form-item label="选择操作人：" prop="bk_uid">
          <el-col :span="24">
            <el-select v-model="timeForm.bk_uid" placeholder="请选择" clearable filterable style="width:100%;">
              <el-option :label="`${v.en_name} ${v.realname}`" :value="v.id" v-for="(v, i) in userList"
                :key="i"></el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label="选择流程：" prop="event_id">
          <el-col :span="24">
            <el-select v-model="timeForm.event_id" placeholder="请选择" style="width: 100%;">
              <el-option label="全部流程" value="0"></el-option>
              <el-option label="支付管理" value="4"></el-option>
              <el-option label="报销管理" value="12"></el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label="备注：" prop="info">
          <el-col :span="24">
            <el-input style="width: 100%;" type="textarea" spellcheck="false" :autosize="{ minRows: 4 }"
              placeholder="请输入内容" v-model="timeForm.info">
            </el-input>
          </el-col>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="trackShow = false">取 消</el-button>
        <el-button type="primary" @click="handleTrack">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="删除报销动态" :visible.sync="delTrackShow" width="600px">
      <ul class="aul ulist" style="padding:0; min-height: 100px;">
        <li>
          <span>时间：</span>
          <span>{{ timeForm.create_time }}</span>
        </li>
        <li>
          <span>操作人：</span>
          <span>{{ timeForm.bkUserArr ? timeForm.bkUserArr.realname : '暂无' }}</span>
        </li>
        <li>
          <span>项目状态：</span>
          <span>{{ dd.track_type[timeForm.event_id] }}</span>
        </li>
        <li>
          <span>详情：</span>
          <span v-html="timeForm.info"></span>
        </li>
      </ul>
      <span slot="footer" class="dialog-footer">
        <el-button @click="delTrackShow = false">取 消</el-button>
        <el-button type="primary" @click="deleteTrack">确 定</el-button>
      </span>
    </el-dialog>

  </el-main>
</template>

<script>
import * as api from '@/api'
import store from '@/store'
import { thousands } from '@/utils/index.js'
export default {
  name: 'expenseView',
  data() {
    return {
      nodeLimtList: [],
      level: '',
      userId: '',
      mType: '4',
      userArr: {
        en_name: '',
        realname: '',
      },
      userList: [],
      itemList: [],
      form: {
        staff: [],
      },
      leaderCheckShow: false,
      leaderCheckForm: {
        leader_check_status: '2', //2审核通过 3审核不通过
        leader_check_info: '',
        leader_no_check_info: '',
      },
      financeCheckShow: false,
      financeCheckForm: {
        finance_check_status: '2', //2审核通过 3审核不通过
        finance_check_info: '',
        finance_no_check_info: '',
      },
      trackForm: {
        project_id: '',
        event_id: '',
      },
      delTrackShow: false,
      timeForm: {
        track_id: '',
        create_time: '',
        bk_uid: '',
        event_id: '',
        info: '',
        option: 1,
      },
      trackList: [],
      trackShow: false,
      currTrack: {//当前动态

      },
      fileNum: 0, //计算附件数量
    }
  },
  computed: {
    parentActive() {
      return (item) => {
        return item.parent && item.active
      }
    },
    myTrackList() {
      return this.trackList.filter((item) => item)
    },
  },
  created() {
    this.query = this.$route.query
    this.query.id && this.getDetail(this.query.id)
  },
  mounted() {
    this.getServiceList()
    this.getUserList()
  },
  watch: {

  },
  methods: {
    checkUrlFn() {
      // 获取当前URL的哈希部分  
      const hash = window.location.hash;  
      // 移除'#'字符  
      const url = hash.substring(1); 
      
      let postData = {
        url_path: url
      }
      api.checkLoginUrl(postData).then((res) => {
        if (res.status == 400) {
          this.$message({
            type: 'info',
            message: '暂无权限',
          })
          this.$router.push({
            path: `/home`
          });
        }
      })
    },
    checkNodeFn(menu_id) {
      let postData = {
        menu_id,
      }
      api.checkNode(postData).then((res) => {
        this.nodeLimtList = res.node_ids.split(',')
      })
    },
    NodeInclude(val) {
      return this.nodeLimtList.includes(val)
    },
    async getUserList() {
      this.$fly
        .post('apiAccount_getUserList.html', {
          per_page: 5000,
        })
        .then((res) => {
          this.userList = res.itemList
        })
    },
    async getServiceList() {
      this.$fly
        .post('ApiAdministrative_serviceTypeDropdownList.html', {
          per_page: 5000,
          id: '10'
        })
        .then((res) => {
          this.serviceList = res
        })
    },
    async getUserDetail(id) {
      this.$fly
        .post('ApiStaffReimbursement_getStaffInfo.html', {
          uid: id,
        })
        .then((res) => {
          this.userArr = res
        })
    },
    getDetail(id) {
      this.checkUrlFn()
      this.checkNodeFn('61')
      const apiUrl = 'ApiStaffReimbursement_getStaffReimbursementDetail.html'
      this.$fly
        .post(apiUrl, {
          reimbursement_id: id,
        })
        .then((res) => {
          this.trackList = res.track_list
          let form = res
          this.isDraft = form.is_draft
          form.expense_date_str = this.dateForm(form.expense_date)[0]
          form.expense_date_year = this.dateForm(form.expense_date)[1]
          form.expense_date_month = this.dateForm(form.expense_date)[2]
          this.getUserDetail(form.user_id)
          const atta_str = () => [{ origin_name: '', file_name: '', httpImg: '', id: '', flist: [] }]
          form.pay_str = res.reimbursement_pay_file.length != 0 ? res.reimbursement_pay_file : atta_str()
          this.itemList = form.reimbursement_detail.map(({ id, service_type, service_type_name, expense_amount, description, brand, project_id, project, reimbursement_file }) => {
            return {
              id,
              service_type,
              service_type_name,
              expense_amount,
              description,
              brand,
              project_id,
              project,
              // contract_no_name: project_id == '0' ? '关联项目' : project.contract_name,
              atta_str: [reimbursement_file,]
            }
          })
          for (let i = 0; i < this.itemList.length; i++) {
            const item = this.itemList[i].atta_str;
            for (let j = 0; j < item.length; j++) {
              const element = item[j];
              if (element.id) {
                this.fileNum += 1
              }
            }
          }
          this.form = form
          this.numberFn()
          setTimeout(() => {
            //权限
            this.level = store.state.level
            this.userId = store.state.userId
          }, 200);
        })
    },
    //计算数字
    numberFn() {
      let expense = 0, daliy = 0, business = 0;
      for (let i = 0; i < this.itemList.length; i++) {
        const _item = this.itemList[i];
        if (_item.service_type == '73' || _item.service_type == '76' || _item.service_type == '77') {
          daliy += Number(_item.expense_amount)
        }
        else if (_item.service_type == '74' || _item.service_type == '75') {
          business += Number(_item.expense_amount)
        }
        expense += Number(_item.expense_amount)
      }
      this.form = {
        ...this.form,
        total_expense_amount: thousands(Number(expense)),
        total_business_amount: thousands(Number(business)),
        total_daily_amount: thousands(Number(daliy)),
      }
    },
    dateForm(str) {
      const strArr = str.split('-')
      return [`${strArr[0]}年${strArr[1]}月`, strArr[0], strArr[1]]
    },
    //编辑报销
    editExpense() {
      if (this.level != '1') {
        if (!this.judgetMent(this.form)) {
          this.$message.error('只有待提交和审核不通过状态才可编辑!')
          return false
        }
      }
      this.$router.push({
        path: '/expense/add',
        query: {
          id: this.form.id,
        },
      })
    },
    showLeaderCheck() {
      if (this.level != '1') {
        if (this.form.leader_check_status == '0') {
          this.$message.error('报销未提交!')
          return false
        }
        if (this.form.leader_check_status == '2' || this.form.leader_check_status == '3') {
          this.$message.error('本条记录已审核!')
          return false
        }
      }
      this.leaderCheckShow = true
    },
    //主管审核
    handleLeaderCheck() {
      this.$fly
        .post('ApiStaffReimbursement_checkStaffReimbursement.html', {
          reimbursement_id: this.form.id,
          option: 2,
          ...this.leaderCheckForm,
        })
        .then((res) => {
          console.log(res);
          this.leaderCheckShow = false
          //还原审核状态
          this.leaderCheckForm = {
            leader_check_status: '2',
            leader_check_info: '',
            leader_no_check_info: '',
          }
          this.query.id && this.getDetail(this.query.id)
        })
    },
    //下载附件
    exportExpenseAttachmentToExcel(file_ids) {
      console.log(file_ids);
      window.location = api.exportExpenseAttachmentToExcel({
        reimbursement_id: this.form.id,
        expense_date: this.form.expense_date,
        file_ids,
      })
    },
    //下载明细
    exportExpenseStaffToExcel() {
      window.location = api.exportExpenseStaffToExcel({
        reimbursement_id: this.form.id
      })
    },
    showFinanceCheck() {
      if (this.level != '1') {
        if (this.form.leader_check_status == '0') {
          this.$message.error('报销未提交!')
          return false
        }
        if (this.form.finance_check_status == '0') {
          this.$message.error('请等待主管审核通过!')
          return false
        }
        if (this.form.finance_check_status == '2' || this.form.finance_check_status == '3') {
          this.$message.error('本条记录已审核!')
          return false
        }
      }
      this.financeCheckShow = true
    },
    //财务审核
    handlefinanceCheck() {
      this.$fly
        .post('ApiStaffReimbursement_checkStaffReimbursement.html', {
          reimbursement_id: this.form.id,
          option: 2,
          ...this.financeCheckForm,
        })
        .then((res) => {
          console.log(res);
          this.financeCheckShow = false
          //还原审核状态
          this.financeCheckForm = {
            finance_check_status: '2',
            finance_check_info: '',
            finance_no_check_info: '',
          }
          this.query.id && this.getDetail(this.query.id)
        })
    },
    //更新支付状态
    updatePayClick() {
      if (this.level != '1') {
        if (this.form.finance_check_status == '0') {
          this.$message.error('请等待主管审核通过!')
          return false
        }
        if (this.form.finance_check_status == '1') {
          this.$message.error('请等待财务审核通过!')
          return false
        }
      }
      this.$router.push({
        path: '/expense/pay',
        query: {
          id: this.form.id,
        },
      })
    },
    compDate(item) {
      return item.smartTime + '' + item.weekTime
    },
    trigger(item) {
      let date = item.date || {}
      this.trackList = this.trackList.map((v) => {
        if (v.date === date) {
          v.active = !v.active
        }
        return v
      })
    },
    trackChange(v) {
      this.$fly
        .post('ApiStaffReimbursement_getTrackList.html', {
          project_id: this.query.id,
          event_id: v,
        })
        .then((res) => {
          this.trackList = res.trackList
        })
    },
    //修改项目动态
    setTimeForm(item) {
      console.log(item);
      const { bk_uid, create_time, event_id, id, info, bkUserArr } = item
      this.timeForm = {
        track_id: id,
        bk_uid,
        create_time,
        event_id,
        info,
        bkUserArr,
      }
    },
    handleCommand(command) {
      if (command == 'a') {
        this.timeForm = {
          track_id: '',
          bk_uid: '',
          create_time: '',
          event_id: '',
          info: '',
        }
        this.timeForm.option = 1
        this.timeForm.project_id = this.form.id
        this.trackShow = true
      }
      else if (command == 'b') {
        delete this.timeForm.bkUserArr
        this.timeForm.option = 2
        this.trackShow = true
      }
      else if (command == 'c') {
        console.log('c');
        this.delTrackShow = true
      }
    },
    handleTrack() {
      this.$fly
        .post('ApiStaffReimbursement_editTrackInfo.html', {
          ...this.timeForm,
          mType: this.mType,
        })
        .then((res) => {
          console.log(res);
          this.trackShow = false
          this.query.id && this.getDetail(this.query.id)
        })
    },
    deleteTrack() {
      this.$fly
        .post('ApiStaffReimbursement_delTrack.html', {
          track_id: this.timeForm.track_id,
          mType: this.mType,
        })
        .then(() => {
          this.delTrackShow = false
          this.query.id && this.getDetail(this.query.id)
        })
    },
    judgetMent(obj) {
      if (obj.status == '0' || (obj.status == '1' && obj.leader_check_status == '3') || (obj.status == '1' && obj.leader_check_status == '2' && obj.finance_check_status == '3')) {
        return true //可编辑
      }
      else if (obj.status == '1' || (obj.status == '1' && obj.leader_check_status == '2') || (obj.status == '1' && obj.leader_check_status == '2' && obj.finance_check_status == '2')) {
        return false //不可编辑
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.header {
  //标题样式
  @extend %box;
  box-sizing: border-box;
  width: 100%;
  background: var(--card); /* 0819修改 */
  padding: 20px 40px;
  margin-bottom: 10px;
  @extend %center;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: flex-start;

  .header-info {
    width: 80%;
    @extend %center;
    align-items: flex-start;
    text-align: left;

    h1 {
      font: 700 28px/1 $font;
      margin-bottom: 16px;
    }

    p {
      font: 16px/2 $font;

      &.info-detail {
        color: #999;
        font: 12px/2 $font;
        white-space: pre-wrap;
      }

      &.pdou {
        span {
          &::after {
            content: ',';
            display: inline-block;
          }

          &:last-of-type {
            &::after {
              display: none;
            }
          }
        }
      }
    }
  }

  .header-status {
    @extend %center;
    flex-flow: row nowrap;

    .button {
      box-sizing: border-box;
      min-width: 100px;
      border-radius: 20px;
      padding: 10px 15px;
      font: 12px/1 $font;
      color: #fff;
    }
  }
}

.materialwrap {
  .form.myform {
    padding-left: 100px;
  }

  .filterwrap {
    display: flex;
    justify-content: flex-end;
    padding: 0 0 15px 0;

    .el-button {
      margin: 0 0 0 20px;
    }
  }

  .base1 {
    @extend %box;
    margin-bottom: 20px;
    padding: 30px 40px;
    position: relative;

    .ntitle {
      display: inline-block;
      margin: 0 0 25px 0;

      &::before {
        width: 100%;
      }
    }

    ul {
      @extend %start;
      color: var(--text-1); /* 0819修改 */;
      background: var(--bg-soft); /* 0819修改 */
      padding: 0 25px;
      border-radius: 20px;
      margin-bottom: 20px;
      position: relative;

      &:last-of-type {
        margin-bottom: 0;
      }

      li {
        width: 50%;
        font: 14px/3 $font;

        p {
          min-height: 42px;
          padding: 5px 0;
          @extend %start;

          label {
            width: 150px;
            white-space: nowrap;
            flex: none;
          }

          .bbox {
            width: 100%;
            padding: 0;
            display: block;

            li {
              width: 100%;
              height: 42px;

              &:last-child {
                width: 100%;
                padding-left: 0;
              }
            }
          }

          .anlist {
            padding: 0;
            width: 100%;
            flex-flow: column nowrap;

            li {
              position: relative;
              width: 100%;

              .bbtn {
                position: absolute;
                top: 50%;
                left: 100%;
                transform: translateY(-50%)
              }
            }
          }

        }
      }
    }
  }
}

.aul.ulist {
  padding: 20px 0;
  font: 14px/2 $font;
  text-align: left;

  >li {
    padding: 0 60px;
    display: flex;
    flex-flow: row nowrap;

    span {
      display: inline-block;

      &:first-of-type {
        width: 30%;
      }

      &:last-of-type {
        width: 70%;
      }
    }
  }

  .ulform {
    padding: 0 60px;
  }

  .el-form-item--small.el-form-item {
    margin-bottom: 0;
  }
}

.linkwrap {
  font-size: 12px;

  &.normal {
    color: #606266;

    a {
      color: #606266;

      &:hover {
        cursor: pointer !important;

        &::after {
          height: 0.2px;
          background-color: #606266;
        }
      }

      >span {
        font-size: 14px;
        color: #606266;
      }
    }

    span {
      color: var(--text-1); /* 0819修改 */;
      font-size: 16px;
      padding: 0 5px;
    }
  }
}

.inblank {
  @extend %center;
  font: 14px/2 $font;
  color: #999;
  background: var(--bg-soft); /* 0819修改 */
  padding: 25px;
  border-radius: 20px;
  margin-bottom: 20px;
  position: relative;
}

.operater {
  @extend %start;
  position: absolute;
  top: 30px;
  right: 40px;
  font: 14px/1 $font;
  text-align: center;

  >div {
    min-width: 32px;
    border: 1px solid #DCDFE6;
    border-radius: 3px;
    padding: 9px 10px;
    cursor: pointer;

    &.linkline {
      border-color: transparent;
      background: transparent;
      color: var(--text-1); /* 0819修改 */;

      &:hover {
        &::after {
          display: block;
          content: '';
          height: 0.1px;
          background: #231f20;
        }
      }
    }

    &.linkbox {
      border-color: #0E0F22;
      background: #0E0F22;
      color: #fff;

      &.grey {
        border-color: #c0c4cc;
        background: #c0c4cc;
        color: #fff !important;

        &:hover {
          background: #c0c4cc;
        }
      }

      &:hover {
        background: rgba($color: #0E0F22, $alpha: 0.8);
      }
    }
  }
}

.circle-tag {
  position: relative;
  top: 11px;

  &:hover {
    .word {
      padding: 0 10px;
    }
  }
}

.dialog-download {
  border-radius: 12px;
  background: #231f20;
  font: 12px/2 $font;
  color: #fff;
  padding: 5px 20px;
  margin: 0 20px;

  &:hover {
    color: #fff;
    background: rgba($color: #0E0F22, $alpha: 0.8);

    &::after {
      display: none;
    }
  }
}


.table {
  position: relative;
  margin-bottom: 20px;

  .expense {
    @extend %start;
    padding: 30px 0;

    >div {
      margin-right: 30px;
    }
  }

  .operater {
    .button {
      box-sizing: border-box;
      min-width: 100px;
      border-radius: 20px;
      padding: 10px 15px;
      font: 12px/1 $font;
      color: #fff;
      cursor: default;
    }
  }
}

.download {
  padding: 10px 0;
  @extend %start;
  justify-content: flex-end;
}

.history {
  @extend %box;
  padding: 30px 40px;
}
</style>

<style lang="scss">
.linehead {
  //时间版头样式
  display: flex;
  flex-flow: row nowrap;
  font: 16px/1 $font;
  color: var(--text-1); /* 0819修改 */
  padding: 25px 55px 0 60px;

  li {
    flex: auto;

    &:nth-child(1) {
      width: 190px;
      flex: none;
    }

    &:nth-child(2) {
      width: 190px;
      flex: none;
    }

    &:nth-child(3) {
      width: 190px;
      flex: none;
    }

    &:nth-child(4) {
      width: 880px;
      flex: none;
    }
  }
}

.timeline {
  //时间版内样式
  margin: 20px 25px 20px 30px;
  padding: 50px 30px;
  border-radius: 6px;
  border: solid 1px #bfbfbf;

  .ico-edit {
    display: block;
    width: 20px;
    height: 20px;
    z-index: 999 !important;
    position: absolute;
    left: -160px;
    top: 0px;
    cursor: pointer;

    ::before {
      font-size: 20px;
      width: 20px;
      height: 20px;
    }
  }

  .mycard {
    min-height: 80px;
    background-color: var(--card); /* 0819修改 */
    border-radius: 4px;
    padding: 0 20px;
    position: relative;
    transform: translateY(-20px);
    // pointer-events: none;

    &.parent {
      pointer-events: auto;
      // cursor: pointer;
    }

    &.active {
      background-color: var(--card); /* 0819修改 */
      height: 30px;

      &:before {
        display: none;
      }

      dl,
      .point {
        display: none;
      }
    }

    &:before {
      content: '';
      font-size: 0;
      border-bottom: 20px solid #f5f5f5;
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      border-top: 10px solid transparent;
      position: absolute;
      top: 0;
      left: -10px;
    }

    dl {
      flex: none;
      display: flex;
      height: 80px;
      flex-flow: column wrap;
      padding: 10px 60px 10px 00px;
      flex-flow: row nowrap;

      dd {
        height: 60px;
        width: 150px;

        &:nth-child(2) {
          width: 180px;
        }

        flex: none;
        display: flex;
        flex-flow: column nowrap;
        align-items: flex-start;
        justify-content: center;

        span {
          font: 14px/30px $font;
        }
      }
    }

    .ul {
      padding: 0;
      display: flex;
      flex-flow: row nowrap;
      position: relative;
      z-index: 999;

      li {
        @extend %center;
        align-items: flex-start;
        min-height: 80px;
        flex: auto;
        font: 14px/20px $font;

        &:nth-child(1) {
          width: 180px;
          flex: none;
        }

        &:nth-child(2) {
          width: 180px;
          flex: none;
        }

        &:nth-child(3) {
          padding-left: 20px;
          display: flex;
          flex-flow: column nowrap;
          padding: 10px 60px 10px 20px;
          box-sizing: border-box;
          text-align: left;

          span {
            font: 14px/30px $font;

            &.grey {
              font-size: 14px;
              color: #999;
            }
          }

          a {
            display: inline-block;
            position: relative;
            z-index: 999999999999999999 !important;
            cursor: pointer;
          }
        }
      }
    }

    .point {
      position: absolute;
      background: $c;
      color: #fff;
      height: 30px;
      font: 16px/30px $font;
      padding: 0 10px;
      border-radius: 15px;
      right: 30px;
      top: 25px;
    }

    .ticon {
      position: absolute;
      left: -160px;
      height: 30px;
      line-height: 30px;
      padding: 0 20px 0 88px;
      color: #fff;
      top: 14px;
    }
  }

  .el-timeline {
    padding-left: 140px;

    .el-timeline-item {
      position: relative;
    }
  }

  .child {
    .el-timeline-item__timestamp.is-top {
      background-color: var(--card); /* 0819修改 */
      color: #9c9a9a;
      text-align: right;
    }
  }

  .el-timeline-item__timestamp.is-top {
    position: absolute;
    left: -140px;
    width: 120px;
    height: 30px;
    background-color: #2696d2;
    border-radius: 4px;
    color: #fff;
    font: 14px/30px $font;
    padding: 0 0 0 10px;
    top: -6px;
    box-sizing: border-box;
  }
}

.pdou {
  span {
    &::after {
      content: ',';
      display: inline-block;
    }

    &:last-of-type {
      &::after {
        display: none;
      }
    }
  }
}

.origin_name {
  @extend %start;

  >a {
    text-align: center;
  }
}

.inner {
  display: block;
  min-height: 23px;

  span {
    margin-right: 10px;
    font-size: 12px;
    display: inline-block;
    max-width: 200px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    cursor: pointer;
  }

}
</style>
